import * as Sentry from '@sentry/react';
import {ApolloError} from '@sail/data';
import type {ErrorCode, ErrorContext} from 'src/v2/state/types';

export const logErrorToSentry = (
  error: unknown,
  context: ErrorContext,
  errorCode: ErrorCode,
): void => {
  Sentry.captureException(error, {
    // Use custom tags for searchable filtering and aggregation in Sentry.
    tags: {
      app_version: 'v2',
      error_context: context,
      error_code: errorCode,
      isApiError: error instanceof ApolloError,
    },
    // Contexts provide additional detailed debugging information.
    contexts: {
      v2_error: {
        context,
        errorCode,
        isApiError: error instanceof ApolloError,
        error,
      },
    },
    // TODO: Can add fingerprints to override Sentry's default grouping algorithm,
    // Errors with same fingerprint = same Sentry issue.
  });
};
